module.exports = __webpack_public_path__ + "static/media/denuncia.d8be08c9.svg";